export default __webpack_public_path__ + "slices/main/assets/public/media/logos/techcrunch.b7243b6d5b43994fccc582a9ba638529.png";